<!-- <div>
<i nz-icon nzType="idcard" nzTheme="twotone" class="header-icon"></i>&nbsp;<b class="header-label">Report Profile</b>
</div> -->

<pg-header
  title="Report Profile"
  ticon="idcard"
  bckbtn="true"
  bckurl="/setup"
></pg-header>
@if (usrAcsErrMsg == false) {
<div>
  <div class="ds-card grid">
    <app-data-grid
      id="gridContainer"
      style="width: 100%"
      [dataSource]="rprtprflLst"
      [legacyColumns]="columnDefs"
      [searchPanel]="true"
      [filterRow]="true"
      [filterPanel]="true"
      [groupPanel]="true"
      [columnChooser]="true"
      [allowExport]="true"
      exportFileName="LMO Details"
      [pageSize]="10"
      [allowedPageSizes]="[10, 25, 50, 100]"
      [showPageSizeSelector]="true"
      [rowAlternationEnabled]="true"
      [showBorders]="true"
    >
      <app-grid-column
        [showInColumnChooser]="false"
        type="buttons"
        [visible]="USER_PERMISSIONS.dlte_in == 1 ? true : false"
        [width]="100"
        caption="Edit"
        cellTemplate="editTemplate"
      ></app-grid-column>
      <ng-template appGridCell="editTemplate" let-data="cell"
        ><div>
          <div class="tblEdtBtn" (click)="onEdit2(data)">Edit</div>
        </div></ng-template
      >
      <app-grid-column
        [showInColumnChooser]="false"
        [visible]="USER_PERMISSIONS.dlte_in == 1 ? true : false"
        type="buttons"
        [width]="100"
        caption="Delete"
        cellTemplate="delTemplate"
      ></app-grid-column>
      <ng-template appGridCell="delTemplate" let-data="cell"
        ><div>
          <div class="tblDelBtn" (click)="onDelete2(data)">Delete</div>
        </div></ng-template
      >
    </app-data-grid>
  </div>
  <nz-drawer
    [nzBodyStyle]="{
      height: 'calc(100% - 55px)',
      overflow: 'auto',
      'padding-bottom': '53px'
    }"
    [nzMaskClosable]="false"
    [nzWidth]="370"
    [nzVisible]="shwSidebar"
    [nzTitle]="sidebarHeading"
    (nzOnClose)="closeSideBar()"
  >
    <form nz-form [formGroup]="rprtprflForm">
      <div class="input-row" nz-row>
        <div
          nz-col
          nzXs="24"
          nzSm="24"
          nzMd="24"
          nzLg="24"
          nzXl="24"
          class="rprtprflMrgn"
        >
          <div class="inptLbl">Report Profile Name</div>
          <input type="text" nz-input formControlName="prfle_nm" />
        </div>
      </div>
      <div class="input-row" nz-row>
        <div
          nz-col
          nzXs="24"
          nzSm="24"
          nzMd="24"
          nzLg="24"
          nzXl="24"
          class="rprtprflMrgn"
        >
          <div class="inptLbl">Report Profile Discription</div>
          <input type="text" nz-input formControlName="prfle_dscrn_tx" />
        </div>
      </div>
      <div class="input-row" nz-row>
        <div
          nz-col
          nzXs="24"
          nzSm="24"
          nzMd="24"
          nzLg="24"
          nzXl="24"
          class="rprtprflMrgn"
        >
          <div class="inptLbl">Select Component Name</div>
          <nz-select
            style="width: 100%"
            nzPlaceHolder="Select Component Name"
            formControlName="cmpnt_nm"
          >
            @for (c of cmpnt_lst; track c) {
            <nz-option [nzValue]="c.cmpnt_id" [nzLabel]="c.cmpnt_nm">
            </nz-option>
            }
          </nz-select>
        </div>
      </div>
    </form>
    <div class="ds-card grid">
      <div class="stpoptsmainhng">Report Options</div>
      <ul class="stpopts" nz-list [nzDataSource]="rptoptnlst" nzBordered>
        <div>
          @for (m of rptoptnlst; track m) {
          <li nz-list-item nzNoFlex>
            <!-- <ul nz-list-item-actions>
                <nz-list-item-action>
                  <label nz-checkbox [(ngModel)]="m.isActive" (ngModelChange)="ischeked($event,m)"></label>
                </nz-list-item-action>
              </ul> -->
            <div class="input-row" nz-row>
              <div nz-col nzXs="22" nzSm="22" nzMd="22" nzLg="22" nzXl="22">
                {{ m.rpt_nm }}
              </div>
              <div nz-col nzXs="2" nzSm="2" nzMd="2" nzLg="2" nzXl="2">
                <!-- <ul nz-list-item-actions>
                  <nz-list-item-action> -->
                <label
                  nz-checkbox
                  [(ngModel)]="m.isActive"
                  (ngModelChange)="ischeked($event, m)"
                ></label>
              </div>
            </div>
            <!-- </nz-list-item-action> -->
            <!-- </ul> -->
          </li>
          }
        </div>
      </ul>
    </div>
    @if (shwschvlymEditDiv==false && shwschvlymDelDiv==false) {
    <button nz-button nzType="primary" class="sbmtBtm" (click)="saverptprfl()">
      Submit
    </button>
    } @if (shwschvlymEditDiv==true && shwschvlymDelDiv==false) {
    <button nz-button nzType="primary" class="sbmtBtm" (click)="updtrptprfl()">
      Update
    </button>
    }
    <button
      nz-button
      nzType="primary"
      nzDanger
      class="cnclBtn"
      (click)="closeSideBar()"
    >
      Cancel
    </button>
  </nz-drawer>
</div>
} @if (usrAcsErrMsg == true) {
<div class="permMsg">
  <nz-result
    nzStatus="error"
    nzTitle="Access Denied"
    nzSubTitle="You do not have permissions to do this operation. Please contact Administrator to get permissions."
  >
    <!-- <div nz-result-extra>
      <button nz-button nzType="primary" (click)="bckToHm()">Back to home</button>
    </div> -->
  </nz-result>
</div>
}
